<template>
    <div>
        <v-dialog v-model="dialog" scrollable max-width="350px">
            <br>
            <!--<v-btn slot="activator" color="primary" dark>Open Dialog</v-btn>-->
            <v-card>
            <v-card-title>Izberite polja za prikaz</v-card-title>
            <v-divider></v-divider>
            <v-card-text style="height: 350px;">
                    <v-checkbox 
                    v-for="(item, index) in this.columns" 
                    :key="index"
                    v-model="selectedItems" 
                    :label="item.text" 
                    :value="item.value">
                    </v-checkbox>
            </v-card-text>
            <v-divider></v-divider>
            <v-card-actions>
                <v-btn color="blue darken-1" flat @click="cancel">Prekliči</v-btn>
                <v-btn color="blue darken-1" flat @click="save">Shrani</v-btn>
            </v-card-actions>
            </v-card>
        </v-dialog>
    </div>
</template>

<script>
import { EventBus } from '@/main.js'

export default {
    name: 'data-table-toggle-columns',
    props: ['dataTableId', 'columns', 'dataTableColumnsMenuId'],

    data: () => ({
        dialog: false,
        selectedItems: []
    }),

    watch: {

    },

    computed: {

    },

    methods: {
        save() {
            //console.log(this.selectedItems)
            EventBus.$emit(this.dataTableId, {
                dataTableHeaders: this.selectedItems
            })

            this.dialog = false
        },

        cancel() {
            this.dialog  = false
            /*EventBus.$emit(this.dataTableId, {
                columns: []
            })*/

            var vm = this
            if(vm.columns != null && vm.columns.length > 0) {
                    this.columns.forEach(column => {
                    if(column.visibility) {
                        vm.selectedItems.push(column.value)
                    }
                })
            }

        }
    },

    created() {
            var vm = this
            EventBus.$on(this.dataTableColumnsMenuId, (data) => {
                if(data.openColumnsMenu) {
                    setTimeout(() => {
                        vm.dialog = true
                    }, 10)
                }
            })

            if(vm.columns != null && vm.columns.length > 0) {
                    this.columns.forEach(column => {
                    if(column.visibility) {
                        vm.selectedItems.push(column.value)
                    }
                })
            }
            
    },

    mounted() {

    },

    destroyed() {

    }
}
</script>

<style scoped>

</style>


